import * as Status from '../components/processActionStatus';

$(() => {
    if (IsOnPage()) {
        Status.Init();
        RefreshAddreseeList();
    }

    function IsOnPage(): boolean {
        return Boolean(document.getElementById('processaction-finalize-page'));
    }

    function RefreshAddreseeList() {
        const grid = window['AddresseeListPartial'] as MVCxClientGridView;

        if (grid) {
            grid.Refresh();
        }
    }
});
